/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editcropenable2Inputs */

const en_editcropenable2 = /** @type {(inputs: Editcropenable2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crop image`)
};

const de_editcropenable2 = /** @type {(inputs: Editcropenable2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bild zuschneiden`)
};

/**
* | output |
* | --- |
* | "Crop image" |
*
* @param {Editcropenable2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const editcropenable2 = /** @type {((inputs?: Editcropenable2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editcropenable2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_editcropenable2(inputs)
	return de_editcropenable2(inputs)
});
export { editcropenable2 as "editCropEnable" }